//===========================================//
//    SHUFFLED INK | INIT INVIEW ELEMENTS    //
//===========================================//

(function($) {
	$(document).ready(function() {


		//-- MOVE CARDS UP --//
		$('#home-why-us .cards-bottom').on( 'inview', function( event, isInView ) {

			if ( isInView ) {

				$(this).addClass( 'move-cards' );

			} else {
				// element has gone out of viewport
			}
		});


	}); // document.ready()
})(jQuery);
